var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-2"},[_vm._v("Simple Excel:")]),_c('kst-button',{staticClass:"is-primary",attrs:{"action-mode":"","tag":"button","module":_vm.Model.Module,"moduleType":_vm.Model.ModuleType.Export},on:{"click":_vm.handleExport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }